import { render } from "./ModelingScriptInfo.vue?vue&type=template&id=5dfd9311&ts=true"
import script from "./ModelingScriptInfo.vue?vue&type=script&lang=ts"
export * from "./ModelingScriptInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__